<p-dialog
        *ngIf="group"
        [header]="'Upload image to ' + group.name"
        [modal]="true"
        [(visible)]="group.upload_dialog_visible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
>
    <div class="content flex flex-column gap-1">
        <div class="inputs flex justify-content-between align-items-center gap-3">
            <div>
                <p class="my-2 font-semibold">Make: </p>
                <p-dropdown
                        appendTo="body"
                        [options]="makes"
                        (onClear)="onMakesClear()"
                        [(ngModel)]="selectedMake"
                        [showClear]="selectedMake != ALL_MAKES_SELECT"
                        optionLabel="name"
                        [filter]="true"
                        filterBy="name"
                        [placeholder]="'Select make'">
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                            <div>{{ selectedOption.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template let-make pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ make.name }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="flex flex-column">
                <div class="flex my-2">
                    <label class="font-semibold">Typical Repair: </label>
                </div>
                <div class="flex">
                    <p-dropdown
                            appendTo="body"
                            [options]="sjcs"
                            [(ngModel)]="selectedSjc"
                            optionLabel="display"
                            placeholder="Select custom typical repair"
                            [filter]="true"
                            [showClear]="true"
                            filterBy="display"
                            [loading]="loading">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex align-items-center gap-2">
                                <div>{{ selectedOption.display }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-selectedItem pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div>{{ selectedItem.display }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <label class="font-semibold w-10rem mb-2">Custom caption: </label>
            <div class="flex flex-column gap-2 mt-2">
                  <textarea
                          rows="5"
                          cols="30"
                          pInputTextarea
                          [(ngModel)]="customCaption">
                  </textarea>
            </div>
        </div>
        <div >
            <p class="my-2 font-semibold">Upload an image:</p>
            <p-fileUpload
                    #fileUpload
                    customUpload
                    name="file"
                    class="custom-file-upload"
                    (uploadHandler)="onUpload($event)"
                    [multiple]="false"
                    [disabled]="loading"
                    [uploadStyleClass]="'green-background'"
                    [cancelStyleClass]="'red-background'"
                    accept="image/*">
                <ng-template pTemplate="content">

                </ng-template>
            </p-fileUpload>
        </div>
        <div *ngIf="loading" class="flex justify-content-center mt-2">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
    </div>
</p-dialog>